// extracted by mini-css-extract-plugin
export default {"page":"Recitals_page__oet1C"};